import validate from "jquery-validation"
import { load } from "recaptcha-v3"

const VALID_CLASS = ""
const INVALID_CLASS = "is-invalid"
const VALID_ROW_CLASS = "fv-plugins-bootstrap5-row-valid"
const INVALID_ROW_CLASS = "fv-plugins-bootstrap5-row-invalid"
const ROW_PATTERN = /^(.*)(col|offset)(-(sm|md|lg|xl))*-[0-9]+(.*)$/

const isSelect2 = (el) => $(el).hasClass("select2")
const isSelectPicker = (el) => $(el).hasClass("selectpicker")
const inInputGroup = (el) => $(el).parent().hasClass("input-group")
const isFormCheck = (el) => $(el).parent().parent().hasClass("form-check")
const isCKEditor = (el) => $(el).hasClass("ckeditor")
const closestRow = (el) => $(el).parents().filter(function () {
    return this.classList.toString().match(ROW_PATTERN)
})


//
// ─── CUSTOM VALIDATION OPTIONS ──────────────────────────────────────────────────
//
export var validationOptions = {
    errorClass: INVALID_CLASS,
    validClass: VALID_CLASS,
    ignore: ".ck",
    focusInvalid: true,
    errorElement: "div",
    //debug: true,

    highlight: function (element, errorClass, validClass) {

        //Add invalid classes to closest rows
        $(element).parent().addClass("has-validation")
        const row = closestRow(element)
        if (row) {
            $(row).removeClass(VALID_ROW_CLASS)
            $(row).addClass(INVALID_ROW_CLASS)
        }

        $(element).removeClass(VALID_CLASS)
        $(element).addClass(INVALID_CLASS)
    },

    unhighlight: function (element, errorClass, validClass) {

        //Add valid classes to closest rows
        $(element).parent().removeClass("has-validation")
        const row = closestRow(element)
        if (row) {
            $(row).removeClass(INVALID_ROW_CLASS)
            $(row).addClass(VALID_ROW_CLASS)
        }

        $(element).removeClass(INVALID_CLASS)
        $(element).addClass(VALID_CLASS)

    },

    errorPlacement(error, element) {

        if (inInputGroup(element)) element = $(element).parent()

        if (isSelect2(element)) element = $(element).next(".select2-container")

        if (isCKEditor(element)) element = $(element).next(".ck")

        error.addClass("invalid-feedback")
        error.insertAfter(element)
    },

    invalidHandler: function (event, validator) {
        event.preventDefault()

        //If Ladda exists, stop all instances
        if (typeof Ladda !== "undefined") Ladda.stopAll();

        return false
    }
}


//
// ─── CUSTOM VALIDATION METHODS ──────────────────────────────────────────────────
//#region 

$.validator.addMethod(
    "secure",
    function (value, element, params) {
        if (value.length === 0) return true;
        return /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[*.!@$%^&(){}\[\]:;<>,.?\/~_+-=|]).{8,}$/.test(value);
    },
    "Must contain at least one uppercase letter, one lower case letter, one number and a special character"
);

//#endregion


//This must be re-run when a new form is created via JS.
$(".validate-form").each(function () {
    prepareFormValidation($(this))
});


function prepareFormValidation(form) {
    $(form).validate(validationOptions);
}



//Captcha forms
if ($(".captcha-form").length > 0) {

    //Public site key from Google must be injected here:
    const captchaSystem = load(process.env.GOOGLE_RECAPTCHA_SITE_KEY)

    $(".captcha-form").on("submit", function (e) {
        e.preventDefault()
        const $form = $(this)

        //Standard form validation
        prepareFormValidation($form)
        if (!$form.valid()) return

        const action = $form.data("captcha-action")
        //const l = Ladda.create($form.find("button[type='submit']")[0])
        _blockForm(undefined, $form)


        captchaSystem.then((recaptcha) => {
            recaptcha.execute(action).then(token => {
                $form.find("input[name='captcha_response']")[0].value = token
                e.target.submit()
            })
        })
    })

    const _blockForm = function (btn, $form) {
        //btn.start()
        $form.find("input,textarea,submit,button,a").attr("readonly", true)
    }


}







export { prepareFormValidation }

